<div [class.edit-mode]="editMode">
  <div *ngIf="game.isRealtimeCollection" class="realtime-indicator"
    ><mat-icon
      matTooltip="Collection of face-offs, interruptions, penalties and shots is optimized for realtime."
      >speed</mat-icon
    ></div
  >

  <label>Event Type:</label>
  <strong>{{ eventType }}</strong>
  <ul *ngIf="!eventType" style="columns: 2">
    <li *ngIf="collectsEventType('face_off')"
      ><strong>f</strong>ace off
      <mat-icon class="realtime-icon" *ngIf="game.isRealtimeCollection"
        >speed</mat-icon
      ></li
    >
    <li
      ><strong>i</strong>nterruption
      <mat-icon class="realtime-icon" *ngIf="game.isRealtimeCollection"
        >speed</mat-icon
      ></li
    >
    <li *ngIf="collectsEventType('oddMenRush')"
      ><strong>o</strong>dd-men-rush</li
    >
    <li><strong>p</strong>ass</li>
    <li *ngIf="collectsEventType('gameRestart')"><strong>r</strong>estart</li>
    <li *ngIf="collectsEventType('turnover')">turnover (<strong>l</strong>ost ball)</li>
    <li
      >penalt<strong>y</strong>
      <mat-icon class="realtime-icon" *ngIf="game.isRealtimeCollection"
        >speed</mat-icon
      ></li
    >
    <li
      ><strong>s</strong>hot
      <mat-icon class="realtime-icon" *ngIf="game.isRealtimeCollection"
        >speed</mat-icon
      ></li
    >
    <li *ngIf="collectsEventType('puckPossession')"
      ><strong>u</strong> {{ isFloorball ? 'ball' : 'puck' }} possession</li
    >
    <li><strong>v</strong>ideo tag</li>
    <li *ngIf="game?.isHighlightCollection"><strong>h</strong>ighlight</li>
    <li>period s<strong>t</strong>art</li>
    <li>period <strong>e</strong>nd</li>
    <li *ngIf="game?.hasOfficiatingCollection"
      ><strong>g</strong>ame incident</li
    >
  </ul>
  <div *ngIf="requiresTeam()">
    <label>Team:</label>
    <strong>{{ team }}</strong>
    <ul *ngIf="!team" style="display: inline; padding-left: 4px">
      <li style="display: inline"><strong>h</strong> {{ game?.homeTeam }}</li>
      <li style="display: inline; margin-left: 4px"
        ><strong>a</strong> {{ game?.awayTeam }}</li
      >
    </ul>
  </div>
  <div *ngIf="requiresPlayer()">
    <label>Player:</label>
    <label *ngIf="player">
      <strong [class.warning]="playerWarning">{{ player }}</strong>
      <label class="position" [matTooltip]="'Position ' + playerPosition">{{
        playerPosition
      }}</label>
      <span
        class="shoots"
        [matTooltip]="'Shoots ' + playerShoots"
        [class.shoots-left]="playerShoots === 'LEFT'"
        [class.shoots-right]="playerShoots === 'RIGHT'"
        >{{ playerShoots }}</span
      >
    </label>
    <label *ngIf="!player"
      ><strong>{{ playerNumberString }}</strong></label
    >
    <label *ngIf="!player && !playerNumberString"
      ><i>Type jersey number</i></label
    >
  </div>
  <div *ngIf="eventType === 'interruption'">
    <ul *ngIf="!interruptionType" style="columns: 2">
      <li *ngIf="collectsInterruptionType('icing')"><strong>i</strong>cing</li>
      <li *ngIf="collectsInterruptionType('offside')"
        ><strong>o</strong>ffside</li
      >
      <li *ngIf="collectsInterruptionType('puck_blocked_by_goalkeeper')"
        ><strong>k</strong> puck stopped by goalkeeper</li
      >
      <li *ngIf="collectsInterruptionType('puck_out') && !isFloorball"
        ><strong>p</strong>uck out</li
      >
      <li *ngIf="isFloorball"><strong>p</strong> ball out</li>
      <li><strong>g</strong>oal</li>
      <li *ngIf="collectsInterruptionType('penalty')"
        >penalt<strong>y</strong></li
      >
      <li *ngIf="collectsInterruptionType('timeout')"
        ><strong>t</strong>imeout</li
      >
      <ng-container *ngIf="isFloorball">
        <li><strong>r</strong> incorrect pass back</li>
        <li><strong>h</strong>igh stick</li>
        <li><strong>k</strong>icking</li>
        <li><strong>s</strong>tick hit</li>
        <li>body <strong>c</strong>ontact</li>
        <li>o<strong>b</strong>struction</li>
        <li>other <strong>f</strong>oul</li>
        <li><strong>o</strong>fficial touches ball</li>
        <li><strong>n</strong> unnatural interruption</li>
      </ng-container>
      <li><strong>u</strong>nspecified</li>
    </ul>
    <div
      *ngIf="
        interruptionType === 'period_start' || interruptionType === 'period_end'
      "
    >
      <label>Interruption Reason:</label>
      <strong>{{ interruptionType }}</strong>
      <div *ngIf="interruptionType === 'period_start'">
        <app-period
          [(ngModel)]="period"
          (ngModelChange)="onPeriodChange($event)"
        ></app-period>
      </div>
    </div>

    <div
      *ngIf="
        interruptionType &&
        interruptionType !== 'period_start' &&
        interruptionType !== 'period_end'
      "
    >
      <label>Interruption Reason:</label>
      <strong>{{ interruptionType }}</strong>
    </div>
    <br />
  </div>
  <div *ngIf="eventType === 'pass'">
    <label>Pass Type:</label>
    <strong>{{ passType }}</strong>
    <ul *ngIf="!passType">
      <li><strong>p</strong>ass</li>
      <li><strong>c</strong>hip</li>
      <li><strong>r</strong>im</li>
      <li><strong>s</strong>hot_pass</li>
    </ul>

    <label *ngIf="passType === 'pass' || passType === 'shot_pass'"
      >Receiver Number:</label
    >
    <label *ngIf="passReceiverPlayer"
      ><strong>{{ passReceiverPlayer }}</strong></label
    >
    <label *ngIf="!passReceiverPlayer"
      ><strong>{{ passReceiverPlayerNumberString }}</strong></label
    >
    <div *ngIf="passType === 'pass' || passType === 'shot_pass'">
      <label>Pass Outcome:</label>
      <strong>{{ passOutcome }}</strong>
      <ul *ngIf="!passOutcome">
        <li><strong>c</strong>omplete</li>
        <li><strong>i</strong>ncomplete</li>
      </ul>
    </div>
  </div>
  <div *ngIf="eventType === 'shot'">
    <label>Shot Outcome:</label>
    <strong>{{ shotOutcome }}</strong>
    <span
      *ngIf="
        game &&
        !game.isLiveCollection &&
        game.dataSet &&
        game.dataSet === 'FULL' &&
        netImpactX &&
        netImpactY
      "
    >
      ({{ netImpactX }}/{{ netImpactY }})</span
    >
    <ul *ngIf="!shotOutcome">
      <li><strong>b</strong>locked</li>
      <li><strong>m</strong>iss</li>
      <li><strong>o</strong>n_goal</li>
      <li><strong>g</strong>oal</li>
      <li><strong>i</strong>ron</li>
    </ul>
    <div *ngIf="shotOutcome === 'blocked'">
      <label>Shot Blocker:</label>
      <label *ngIf="shotBlockerPlayer"
        ><strong>{{ shotBlockerPlayer }}</strong></label
      >
      <label *ngIf="!shotBlockerPlayer"
        ><strong>{{ shotBlockerPlayerNumberString }}</strong></label
      >
    </div>
    <div *ngIf="game.isAssistsCollection && shotOutcome === 'goal'">
      <label>Primary Assist:</label>
      <label *ngIf="assist1Player"
        ><strong>{{ assist1Player }}</strong></label
      >
      <label *ngIf="!assist1Player"
        ><i>{{ assist1PlayerNumberString }}</i></label
      >
    </div>
    <div *ngIf="game.isAssistsCollection && shotOutcome === 'goal'">
      <label>Second Assist:</label>
      <label *ngIf="assist2Player"
        ><strong>{{ assist2Player }}</strong></label
      >
      <label *ngIf="!assist2Player"
        ><i>{{ assist2PlayerNumberString }}</i></label
      >
    </div>
    <div *ngIf="shotOutcome && game.isCollectionLiteOrPlus()">
      <label>Attack Scenario:</label>
      <strong>{{ attackScenario }}</strong>
      <ul *ngIf="!attackScenario">
        <li *ngFor="let option of attackScenarios">
          <strong>{{ option.hotkey }}:</strong>{{ option.label }}
        </li>
      </ul>
    </div>
    <div *ngIf="shotOutcome && attackScenario">
      <label>Shot Scenario:</label>
      <strong>{{ shotScenario }}</strong>
      <ul *ngIf="!shotScenario">
        <li><strong>r</strong>egular</li>
        <li>r<strong>e</strong>bound</li>
        <li><strong>q</strong>uick_release</li>
        <li><strong>o</strong>ne_timer</li>
      </ul>
    </div>
    <div *ngIf="shotOutcome && shotScenario">
      <label>Shot Type:</label>
      <strong>{{ shotType }}</strong>
      <ul *ngIf="!shotType">
        <li><strong>w</strong>rist shot</li>
        <li><strong>s</strong>lap shot</li>
        <li><strong>b</strong>ackhand shot</li>
        <li><strong>d</strong>eflection</li>
      </ul>
    </div>
    <div *ngIf="shotOutcome && shotScenario && shotType === 'deflection'">
      <label>Deflector:</label>
      <strong>{{ deflectorPlayer }}</strong>
    </div>
    <div *ngIf="shotOutcome && shotScenario && shotType">
      <label>Net Traffic:</label>
      <strong *ngIf="has_net_traffic !== undefined">{{
        has_net_traffic === '0' ? 'no' : 'yes'
      }}</strong>
      <ul *ngIf="!has_net_traffic">
        <li><strong>n</strong>o</li>
        <li><strong>y</strong>es</li>
      </ul>
    </div>
    <div *ngIf="has_net_traffic === '1'">
      <label>Net Traffic Causer:</label>
      <label *ngIf="netTrafficCauserPlayer"
        ><strong>{{ netTrafficCauserPlayer }}</strong></label
      >
      <label *ngIf="!netTrafficCauserPlayer"
        ><strong>{{ netTrafficCauserPlayerNumberString }}</strong></label
      >
    </div>
    <div *ngIf="has_net_traffic">
      <label>Screen:</label>
      <strong *ngIf="has_screen !== undefined">{{
        has_screen === '0' ? 'no' : 'yes'
      }}</strong>
      <ul *ngIf="!has_screen">
        <li><strong>n</strong>o</li>
        <li><strong>y</strong>es</li>
      </ul>
    </div>
    <div *ngIf="has_screen === '1'">
      <label>Screener:</label>
      <label *ngIf="screenerPlayer"
        ><strong>{{ screenerPlayer }}</strong></label
      >
      <label *ngIf="!screenerPlayer"
        ><strong>{{ screenerPlayerNumberString }}</strong></label
      >
    </div>
  </div>
  <div *ngIf="eventType === 'face_off'">
    <label>Team Outcome:</label>
    <strong>{{ teamFaceOffOutcome }}</strong>
    <ul *ngIf="!teamFaceOffOutcome" style="display: inline; padding-left: 0">
      <li style="display: inline"><strong>w</strong>in</li>
      <li style="display: inline; margin-left: 4px"><strong>l</strong>ose</li>
    </ul>

    <label style="margin-left: 4px">Opponent:</label>
    <label *ngIf="faceOffOpponentPlayer"
      ><strong [class.warning]="faceOffOpponentPlayerWarning">{{
        faceOffOpponentPlayer
      }}</strong></label
    >
    <label *ngIf="!faceOffOpponentPlayer"
      ><strong>{{ faceOffOpponentPlayerNumberString }}</strong></label
    >
  </div>
  <div *ngIf="eventType === 'penalty' && !game.isRealtimeCollection">
    <label>Fouled Player:</label>
    <label *ngIf="fouledPlayer"
      ><strong>{{ fouledPlayer }}</strong></label
    >
    <label *ngIf="!fouledPlayer"
      ><strong>{{ fouledPlayerNumberString }}</strong></label
    >
  </div>
  <div *ngIf="eventType === 'videoTag'">
    <label>Video Tag:</label>
    <strong>{{ videoTag }}</strong>
    <ul *ngIf="!videoTag">
      <li><strong>d:</strong>Low break-out under pressure</li>
      <li
        ><strong>f:</strong>Defensive zone board sector break-out under
        pressure</li
      >
      <li><strong>b:</strong>Defenseman offensive blue line puck management</li>
      <li><strong>z:</strong>Controlled offensive zone entry</li>
      <li><strong>s:</strong>Set break-out</li>
    </ul>
    <div *ngIf="videoTag === 'set_break_out'">
      <label>Defensive Reaction:</label>
      <strong>{{ defensiveReaction }}</strong>
      <ul *ngIf="!defensiveReaction">
        <li *ngFor="let reaction of defensiveReactions">
          <strong>{{ reaction.hotkey }}:</strong>{{ reaction.label }}
        </li>
      </ul>
    </div>
  </div>
  <div *ngIf="eventType === 'gameRestart'">
    <label>Restart Type:</label>
    <strong>{{ gameRestartType }}</strong>
    <ul *ngIf="!gameRestartType" style="columns: 2">
      <li *ngFor="let restartType of gameRestartTypes">
        <strong>{{ restartType.hotkey }}:</strong>{{ restartType.label }}
      </li>
    </ul>
    <div *ngIf="gameRestartType && gameRestartReasons.length > 0">
      <label>Restart Reason:</label>
      <strong>{{ gameRestartReason }}</strong>
      <ul *ngIf="!gameRestartReason" style="columns: 2">
        <li *ngFor="let restartReason of gameRestartReasons">
          <strong>{{ restartReason.hotkey }}:</strong>{{ restartReason.label }}
        </li>
      </ul>
    </div>
  </div>
  <div *ngIf="eventType === 'turnover'">
    <label>Turnover:</label>
    <strong>{{ turnoverType }}</strong>
    <ul *ngIf="!turnoverType" style="columns: 2">
      <li *ngFor="let option of turnoverTypes">
        <strong>{{ option.hotkey }}:</strong>{{ option.label }}
      </li>
    </ul>
    <div *ngIf="turnoverType">
      <label>Possession Change:</label>
      <strong>{{ turnoverScenario }}</strong>
      <ul *ngIf="!turnoverScenario">
        <li *ngFor="let option of turnoverScenarios">
          <strong>{{ option.hotkey }}:</strong>{{ option.label }}
        </li>
      </ul>
    </div>
    <div *ngIf="turnoverScenario">
      <label>Won By:</label>
      <label *ngIf="turnoverOpponentPlayer"
        ><strong>{{ turnoverOpponentPlayer }}</strong></label
      >
      <label *ngIf="!turnoverOpponentPlayer"
        ><strong>{{ turnoverOpponentPlayerNumberString }}</strong></label
      >
      <label
        *ngIf="!turnoverOpponentPlayer && !turnoverOpponentPlayerNumberString"
        ><i>Type the opponent's jersey number</i></label
      >
    </div>
  </div>
  <div *ngIf="eventType === 'highlight'">
    <label>Highlight Type:</label>
    <strong>{{ highlightType }}</strong>
    <ul *ngIf="!highlightType" style="columns: 2">
      <li>b<strong>e</strong>nch</li>
      <li><strong>b</strong>looper</li>
      <li><strong>c</strong>lose up</li>
      <li>c<strong>o</strong>mpilation</li>
      <li><strong>g</strong>oal</li>
      <li>h<strong>i</strong>ghlight play</li>
      <li><strong>h</strong>it</li>
      <li><strong>p</strong>enalty box</li>
      <li>pena<strong>l</strong>ty shot</li>
      <li>s<strong>a</strong>ve</li>
      <li><strong>s</strong>hot</li>
      <li>sta<strong>n</strong>ds</li>
      <li><strong>t</strong>itles</li>
      <li><strong>v</strong>ideo review</li>
    </ul>
    <div
      *ngIf="
        highlightType &&
        !(
          highlightType === 'goal' ||
          highlightType === 'save' ||
          highlightType === 'penalty_shot' ||
          highlightType === 'video_review'
        )
      "
    >
      <label>Playback:</label>
      <strong>{{ highlightPlayback }}</strong>
      <ul *ngIf="!highlightPlayback">
        <li><strong>n</strong>ormal</li>
        <li><strong>s</strong>low motion</li>
      </ul>
    </div>
    <div *ngIf="highlightType === 'video_review'">
      <li><strong>c</strong>oaches challenge</li>
      <li><strong>v</strong>ideo review</li>
    </div>
    <div
      *ngIf="
        (highlightPlayback &&
          highlightType &&
          !(highlightType === 'titles' || highlightType === 'video_review')) ||
        (highlightType &&
          (highlightType === 'goal' ||
            highlightType === 'save' ||
            highlightType === 'penalty_shot'))
      "
    >
      <label>Rating:</label>
      <app-star-rating
        style="float: right"
        [starCount]="5"
        [color]="'primary'"
        [ngModel]="highlightRating"
        (ngModelChange)="ratingChange($event)"
      ></app-star-rating>
    </div>
  </div>

  <div *ngIf="eventType === 'game_incident'">
    <label>Game Incident Type:</label>
    <strong>{{ gameIncidentType }}</strong>
    <ul *ngIf="!gameIncidentType" style="columns: 3">
      <li *ngFor="let gameIncident of getGameIncidentTypeShortcuts()">
        <app-video-keyboard-shortcut
          [shortcutKey]="gameIncident.shortcutKey"
          [label]="gameIncident.label"
        >
        </app-video-keyboard-shortcut>
      </li>
    </ul>
  </div>

  <div *ngIf="isCallableGameIncidentEvent()">
    <label>Official's Action:</label>
    <strong>{{ officialsCallAction }}</strong>
    <ul *ngIf="!officialsCallAction" style="columns: 3">
      <li *ngFor="let action of getOfficialsCallActionShortcuts()">
        <app-video-keyboard-shortcut
          [shortcutKey]="action.shortcutKey"
          [label]="action.label"
        >
        </app-video-keyboard-shortcut>
      </li>
    </ul>
  </div>



  <div *ngIf="
      eventType === 'game_incident' &&
      !!officialsCallAction &&
      hasOfficiatingFullCollection
    ">
    <label>Official 1:&nbsp;</label>
    <i *ngIf="!official1 && !official1Str"
    >Type jersey number</i
    >
    <strong *ngIf="!official1">{{official1Str}}</strong>
    <strong *ngIf="official1" [class.warning]="isInvalidOfficialRoleForGameIncidentType(official1)">{{official1.jerseyNumber ?? '##'}} - {{official1.lastName}} {{official1.firstName}}</strong>
  </div>

  <div *ngIf="isCallableGameIncidentEvent()">
    <label>Call Situation:</label>
    <strong>{{ officialsCallSituation }}</strong>
    <ul *ngIf="!officialsCallSituation" style="columns: 3">
      <li *ngFor="let situation of getOfficialsCallSituationsShortcuts()">
        <app-video-keyboard-shortcut
          [shortcutKey]="situation.shortcutKey"
          [label]="situation.label"
        >
        </app-video-keyboard-shortcut>
      </li>
    </ul>
  </div>

  <div
    *ngIf="
      eventType === 'game_incident' &&
      !!officialsCallAction &&
      !!officialsCallSituation &&
      hasOfficiatingFullCollection
    ">
    <label>Official 2:&nbsp;</label>
    <i *ngIf="officialsCallSituation && official1 && !official2 && !official2Str"
    >Type jersey number</i
    ><strong *ngIf="!official2">{{official2Str}}</strong>
    <strong *ngIf="official2" [class.warning]="isInvalidOfficialRoleForGameIncidentType(official2)">{{official2.jerseyNumber ?? '##'}} - {{official2.lastName}} {{official2.firstName}}</strong>
  </div>


  <div *ngIf="
      eventType === 'game_incident' &&
      officialsCallAction &&
      officialsCallSituation &&
      (official1 || !hasOfficiatingFullCollection) &&
      gameIncidentType === 'penalty' &&
      !gameIncidentReason
    "
  >
    <label>Game Incident Reason Type:</label>
    <strong>{{ gameIncidentReasonType }}</strong>

    <ul *ngIf="!gameIncidentReasonType" style="columns: 3">
      <li *ngFor="let reason of getGameIncidentReasonTypeShortcuts()">
        <app-video-keyboard-shortcut
          [shortcutKey]="reason.shortcutKey"
          [label]="reason.label"
        >
        </app-video-keyboard-shortcut>
      </li>
    </ul>
  </div>

  <div
    *ngIf="
      eventType === 'game_incident' &&
      officialsCallAction &&
      officialsCallSituation &&
      gameIncidentType === 'penalty' &&
      (gameIncidentReasonType !== null || !!gameIncidentReason)
    "
  >
    <label>Game Incident Reason:</label>
    <strong>{{ gameIncidentReason }}</strong>

    <ul *ngIf="!gameIncidentReason" style="columns: 3">
      <li
        *ngFor="
          let gameIncident of getGameIncidentReasonShortcutsForType(
            gameIncidentReasonType
          )
        "
      >
        <app-video-keyboard-shortcut
          [shortcutKey]="gameIncident.shortcutKey"
          [label]="gameIncident.label"
        >
        </app-video-keyboard-shortcut>
      </li>
    </ul>
  </div>
  <div
    *ngIf="eventType === 'game_incident' && gameIncidentType === 'situation'"
  >
    <label>Game Incident Situation:</label>
    <strong>{{ gameIncidentSituation }}</strong>

    <ul *ngIf="!gameIncidentSituation" style="columns: 2">
      <li *ngFor="let situation of getGameIncidentSituationShortcuts()">
        <app-video-keyboard-shortcut
          [shortcutKey]="situation.shortcutKey"
          [label]="situation.label"
        >
        </app-video-keyboard-shortcut>
      </li>
    </ul>
  </div>
</div>
